import { render, staticRenderFns } from "./CardDonation.vue?vue&type=template&id=660b80ca&"
import script from "./CardDonation.vue?vue&type=script&lang=js&"
export * from "./CardDonation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports